import React, { ReactElement, useState } from 'react';
import classnames from 'classnames';
import { File } from 'v2/models';
import styles from './fileItem.module.scss';
import { formatTextNewlines } from 'v2/utils/textFormat';
import fileImage from 'v2/images/file-icon.svg';
import fileFolderImage from 'v2/images/file-folder-icon.svg';
import PreprocessFileMessage from './PreprocessFileMessage';
import FileItemActions from './FileItemActions';
import { downloadDRMFile } from 'v2/utils/drmFileUtils';
import { FilePath } from '../../FilePath/FilePath';
import ActivityItemDescription from '../../ActivityTab/ActivityItems/ActivityItemDescription';
import { getFileDepth } from '../../FilePath/getPartsToDisplay';
import { formatDate } from 'v2/utils/dateUtils';

interface FileItemProps {
  file: File;
  associationsComponent: ReactElement;
}
const FileItem = ({ file, associationsComponent }: FileItemProps) => {
  const [truncated, setTruncated] = useState(false);
  const [expanded, setExpanded] = useState(false);

  const handleTruncate = (_truncated: boolean) => {
    if (_truncated && _truncated !== truncated) {
      setTruncated(_truncated);
    }
  };

  const downloadFile = async () => {
    downloadDRMFile(`/dj/api/v1/file/${file.id}/download`, file.name);
  };

  const expandDescription = () => {
    truncated && setExpanded(!expanded);
  };

  const { depth } = getFileDepth(file.name, file.relative_path);

  const image = depth > 1 ? fileFolderImage : fileImage;

  return (
    <div className={classnames(styles.itemContainer)}>
      <div className={styles.itemHeader}>
        <img src={image} alt="file-icon" className={styles.icon} />
        <div>
          <div className={classnames(styles.nameContainer)}>
            <button
              title={file.relative_path || file.name}
              className={styles.name}
              onClick={downloadFile}
            >
              <FilePath file={file} />
            </button>
          </div>

          <span data-cy="fileOwner" className={classnames(styles.fileOwner)}>
            By {file.owner.first_name} {file.owner.last_name} on{' '}
            {formatDate(file.timestamp, false)}
          </span>
          <div className={styles.associations}>{associationsComponent}</div>
        </div>
        <FileItemActions file={file} />
      </div>
      {file.description ? (
        <div className={classnames(styles.fileDescription)}>
          <ActivityItemDescription
            content={file.description}
            render={(content) => formatTextNewlines(content)}
            expanded={expanded}
            setExpanded={expandDescription}
            truncated={truncated}
            handleTruncate={handleTruncate}
          />
        </div>
      ) : null}
      <PreprocessFileMessage file={file} />
    </div>
  );
};

export default FileItem;
